<script>

import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import addTimeSlot from "./add-time-slot";

export default {
  components: { Layout, PageHeader, addTimeSlot },
  data() {
    return {};
  },
};
</script>

<template>
  <Layout>
   <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-briefcase"></i>
              </span>
            </div>
             <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ trans.trans('__JSON__.Add Time Slot') }}</h4>
               <p><router-link :to="{ name: 'time-slot-list'}">{{ trans.get('__JSON__.Time Slots') }}</router-link> > {{ trans.get('__JSON__.Add Time Slot') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <add-time-slot />
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>